export default __webpack_public_path__ + "static/media/claims.358ccaa7.svg";